import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../utils/api';
import './Login.css';

const ResetPassword: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!token) {
      setError('Ungültiger Link.');
      return;
    }
    if (password.length < 8) {
      setError('Das Passwort muss mindestens 8 Zeichen haben.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }
    setLoading(true);
    setMessage('');
    setError('');
    try {
      await api.post('/auth/reset-password', { token, password });
      setMessage('Passwort erfolgreich geändert. Du kannst dich jetzt einloggen.');
      setPassword('');
      setConfirmPassword('');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Passwort konnte nicht geändert werden.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>🦆 Cruising Ducks</h1>
        <h2>Neues Passwort</h2>
        {message && <div className="info-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="newPassword">Neues Passwort</label>
            <input
              type="password"
              id="newPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmNewPassword">Passwort bestätigen</label>
            <input
              type="password"
              id="confirmNewPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Speichert...' : 'Passwort setzen'}
          </button>
        </form>
        <p className="register-link">
          Zurück zum <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;

